import React from "react";
import { Typography } from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";
import DesignImg5 from "../../../assets/SvgIcons/DesignImg5.svg";
import DesignImg6 from "../../../assets/SvgIcons/DesignImg6.svg";
import "../JaldiLab.css";
import {
  getTextContentHeading,
  h1style,
  h2style,
  h3style,
  h4style,
  paraStyle,
  sectionStyle,
} from "./ChapterList";
import objective from "../../../assets/SvgIcons/obj.svg";
import adjacencies from "../../../assets/SvgIcons/adjacencies.svg";
import designConsideration from "../../../assets/SvgIcons/design-consideration.svg";

const CanteenFacilities = ({ goToSection }) => {

  const canteenObjective = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        <span style={{ color: "#DC002D" }}>
          Provide convenient, hygienic and welcoming dining spaces{" "}
        </span>{" "}
        for Court staff, lawyers, and other visitors to the Court Complex;{" "}
      </>,
      <>
        <span style={{ color: "#DC002D" }}>Adopt eco-friendly practices </span>{" "}
        such as waste management and sustainable sourcing of materials, meal
        preparations and maintenance;{" "}
      </>,
      <>
        <span style={{ color: "#DC002D" }}>Ensure diverse meal options </span>{" "}
        to cater to the needs of diverse users; and{" "}
      </>,
      <>
        <span style={{ color: "#DC002D" }}>Ensure a comfortable space </span> to
        foster social interactions.{" "}
      </>,
    ],
    isOrdered: true,
    isImage: true,
  };
  const canteenAdj = {
    icon: <img src={adjacencies} />,
    heading: "Adjacencies",
    data: [
      "A number of canteen spaces may be provided in strategic locations throughout the Court Complex, depending on the number of users.",
      <>
        Wherever possible, a separate canteen space may be provided for the use
        of lawyers, by the Bar Association (
        <span
          style={sectionStyle}
          onClick={() => {
            goToSection("advocatesBarAssociation", "introduction");
          }}
        >
          Section 2.6.A.
        </span>
        ).
      </>,
      "Separate canteen facilities should be provided for the staff members and Judicial Officers in the internal areas of the Court Complex. ",
    ],
    isOrdered: true,
    isImage: true,
  };
  const canteenDesign = {
    icon: <img src={designConsideration} />,
    heading: "Design Considerations",
    data: [
      "The canteen design must be accessible to diverse user groups.",
      "The layout of the canteen must be optimised to accommodate dining areas, kitchen, service counters, and storage.",
      "The canteen must be an adaptable space, which can accommodate varying mealtime demands or special events, if necessary.",
      "The kitchen layout must be optimised to ensure efficient workflow and safety for staff.",
      "Strict hygiene practices must be adopted in the food preparation, storage and service areas, to ensure compliance with health and safety regulations.",
      "Eco-friendly practices such as waste management and sustainable sourcing of materials, meal preparations, and maintenance and operations must be adopted.",
      "Technology such as digital menu boards, cashless ordering systems, etc., may be utilised for ensuring efficient services.",
    ],
    isOrdered: true,
    isImage: true,
  };
  return (
    <div>
      <Typography>
        <h1 id="handbookPrinciple" style={h1style}>
          PART C - THE HANDBOOK
        </h1>
        <h2 id="commonAmenities" style={h2style}>
          <span style={{ fontSize: "24px" }}>3. </span>COMMON AMENITIES
        </h2>
        <h3 id="canteenFacilities" style={h3style}>
          <span style={{ fontSize: "20px" }}>3.2. </span>Canteen Facilities
        </h3>
        <p style={paraStyle}>
          The Court Complex must provide adequate Canteen facilities to meet the
          needs of all users. Segregated canteens must be provided for the
          Advocates, staff, and the litigants and general public.
        </p>
        {getTextContentHeading(canteenObjective)}
        {getTextContentHeading(canteenAdj)}
        {getTextContentHeading(canteenDesign)}
      </Typography>
    </div>
  );
};

export default CanteenFacilities;
